/* @jsx h */
import { defineComponent, h } from "vue";
import { PaymentDetails, Order, RestaurantProfile } from "@lemmonhq/types";
import { PaymentReceiptMain } from "@lemmonhq/blogic/components";

export interface PaymentOverviewComponentProps {
  payment: PaymentDetails;
  shop: RestaurantProfile;
  orders?: Order[];
  relatedPayment?: PaymentDetails;
}

export const PaymentOverviewComponent =
  defineComponent<PaymentOverviewComponentProps>({
    name: "PaymentOverviewComponent",
    props: ["payment", "shop", "orders", "relatedPayment"],
    setup(props) {
      return () => (
        <div class="flex-1 overflow-y-auto p-4">
          <PaymentReceiptMain
            payment={props.payment}
            shop={props.shop}
            orders={props.orders}
            relatedPayment={props.relatedPayment}
          />
        </div>
      );
    },
  });
